<template>
    <div class="main-container payment">
        <div class="people-error" role="alert" v-if="status === 'payment_errors'">
            <div class="alert-badge">
                <i class="far fa-exclamation-triangle"></i>
            </div>
            <div class="alert-details">
                <p class="alert-message">
                    {{ error_message }}
                </p>
            </div>
            <ul class="error-items" v-if="payment_errors">
                <li v-for="error in payment_errors">{{ error }}</li>
            </ul>
        </div>
        <div class="people-container p-5">
            <h2>
                Payment <span class="total">{{ currancy.format(payment.amount ?? 0) }}</span>
            </h2>
            <div class="w-full flex items-center mb-4">
                <div class="mr-5">
                    <v-switch v-model="is_invoiceable" inset hide-details></v-switch>
                </div>
                <div>Use Invoice Code</div>
            </div>
            <div class="flex flex-wrap" v-if="is_invoiceable">
                <div class="w-full">
                    <label>Invoice Code</label>
                    <input type="text" v-model="invoice_code" />
                </div>
            </div>
            <div class="flex flex-wrap" v-if="!is_invoiceable">
                <div class="w-full">
                    <label>Cardholder's Name</label>
                    <input type="text" v-model="payment.card_holder" />
                </div>
                <div class="w-full">
                    <label>Card Number</label>
                    <input type="email" v-model="payment.card_number" />
                </div>
                <div class="w-full">
                    <label>Card Verfication Code</label>
                    <input type="text" v-model="payment.cvc" />
                </div>
                <div class="md:pr-2 w-full md:w-1/2">
                    <label>Expiration Month</label>
                    <select-month v-model="payment.expiration_month"></select-month>
                </div>
                <div class="md:pl-2 w-full md:w-1/2">
                    <label>Expiration Year</label>
                    <select-year v-model="payment.expiration_year"></select-year>
                </div>
            </div>
        </div>
        <div class="flex justify-between items-center">
            <button-back class="primary-outline" to="/billing"></button-back>
            <button class="primary" v-on:click="processPayment" :disabled="status === 'processing_payment'">
                <i class="fad fa-spinner-third fa-spin" v-if="status === 'processing_payment'"></i>
                {{ button_contiue_text }}
            </button>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import ButtonBack from "@/components/ButtonBack.vue";
import SelectYear from "@/components/SelectYear.vue";
import SelectMonth from "@/components/SelectMonth.vue";
import moment from "moment";

export default {
    name: "PaymentView",
    components: {
        ButtonBack,
        SelectYear,
        SelectMonth,
    },
    data() {
        return {
            is_invoiceable: false,
            button_contiue_text: "Process Payment",
            payment: {
                card_holder: "",
                card_number: "",
                cvc: "",
                expiration_month: "",
                expiration_year: "",
                description: "People Submission",
            },
            payment_errors: [],
            status: null,
            order: JSON.parse(sessionStorage.getItem("people_billing")),
            completed_order: null,
            currancy: new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
            }),
        };
    },
    mounted() {
        this.emitter.emit("updateProgress", { step: 6 });

        this.order.token = localStorage.getItem("people_token");
        this.order.account_id = 1;

        this.setTotal();
    },
    methods: {
        sendEmail() {
            const vue = this;

            const email = this.buildEmail();

            axios.post(ibj_people_payment_api_url + "api/services/email/send", {
                to: this.order.email,
                bcc: "cschultz@ibj.com, pjohns@ibj.com, jbelcher@ibj.com, jsmith@ibj.com, lswank@ibj.com",
                from: "no-reply@ibj.com",
                subject: "IBJ - People on the Move Submission",
                body: email,
            });
        },
        setTotal() {
            const vue = this;
            axios
                .get(ibj_people_api_url + "api/cart/total/" + this.order.token)
                .then((response) => {
                    vue.payment.amount = parseFloat(response.data.cart.total.replace(/,/g, ""));
                    vue.order.amount = parseFloat(response.data.cart.total.replace(/,/g, ""));
                })
                .catch((error) => {
                    vue.order.amount = 0;
                });
        },
        async processPayment() {
            this.status = "processing_payment";
            this.button_contiue_text = "Processing Payment";
            this.payment_errors = [];

            if (this.payment.amount == 0 || this.payment.amount != this.order.amount) {
                this.status = "payment_errors";
                this.error_message = "Oops, we have a problem:";
                this.payment_errors = ["The amount you are trying to pay does not match the amount in your cart."];
                this.button_contiue_text = "Continue";
                scroll(0, 0);
                return false;
            }

            var allowed_invoice_codes = ['FY68M2'];

            if (this.is_invoiceable && allowed_invoice_codes.indexOf(this.invoice_code) == -1) {
                this.status = "payment_errors";
                this.error_message = "Oops, we have a problem:";
                this.payment_errors = ["The invoice code is invalid."];
                this.button_contiue_text = "Continue";
                scroll(0, 0);
                return false;
            }

            if (!this.is_invoiceable) {
                const charged_credit_card = await this.chargeCreditCard();

                if (charged_credit_card) {
                    const stored_order = await this.StoreOrder();

                    if (stored_order) {
                        this.sendEmail();
                        localStorage.people_transaction_id = this.order.transaction_id;
                        const router = this.$router;
                        router.push("/confirmation");
                    }
                }
            } else {
                this.order.transaction_id = "NVC" + "" + Date.now();
                const stored_order = await this.StoreOrder();

                if (stored_order) {
                    this.sendEmail();
                    localStorage.people_transaction_id = this.order.transaction_id;
                    const router = this.$router;
                    router.push("/confirmation");
                }
            }
        },
        async chargeCreditCard() {
            const vue = this;
            const results = await axios
                .post(ibj_people_payment_api_url + "api/pps/charge-credit-card", vue.payment)
                .then(function (response) {
                    vue.order.transaction_id = response.data.transaction_id;
                    return true;
                })
                .catch(function (error) {
                    vue.status = "payment_errors";
                    vue.error_message = "Oops, we have a problem:";
                    vue.payment_errors = error.response.data.errors;
                    vue.button_contiue_text = "Continue";
                    scroll(0, 0);
                    return false;
                });

            return results;
        },
        async StoreOrder() {
            const vue = this;
            const results = await axios
                .post(ibj_people_api_url + "api/orders", vue.order)
                .then(function (response) {
                    vue.completed_order = response.data.order;
                    return true;
                })
                .catch(function (error) {
                    if (!vue.is_invoiceable) {
                        vue.voidTransaction(vue.order.transaction_id);
                    }
                    vue.status = "payment_errors";
                    vue.error_message = "Oops, we have a problem:";
                    const errors = error.response.data.errors;
                    for (const [key, value] of Object.entries(errors)) {
                        vue.payment_errors.push(value[0]);
                    }
                    vue.button_contiue_text = "Continue";
                    scroll(0, 0);
                    return false;
                });

            return results;
        },
        voidTransaction(transaction_id) {
            axios.post(ibj_people_payment_api_url + "api/pps/void-transaction", { transaction_id: transaction_id });
        },
        buildEmail() {
            let items = "";

            this.completed_order.people.forEach((person) => {
                let schedule_html = "";

                person.schedules.forEach((schedule) => {
                    schedule_html += `<p style="font-family:Gotham, 'Helvetica Neue', Helvetica, Arial, sans-serif; padding:0; font-size:14px; line-height:21px; margin:2px 0; text-align:left;"><strong>${schedule.product.name
                        }</strong> | <span style="font-size:12px;"><strong>Run Date:</strong> ${schedule.run_date == "2000-01-01" || schedule.run_date == "0000-00-00"
                            ? "TBD"
                            : moment(schedule.run_date).format("MMMM D, YYYY")
                        } <strong>Amount:</strong> $${schedule.amount}</span></p>`;
                });

                items += `<tr style="padding:0; margin:0;">
					<td style="font-family:Arial, Helvetica, sans-serif;">
						<p style="font-family:Gotham, 'Helvetica Neue', Helvetica, Arial, sans-serif; padding:0; font-size:14px; line-height:21px; margin:10px 0; text-align:left;">
							Announcement - ${person.first_name} ${person.last_name} - <a href="${person.cropped_image}">View Image</a>
						</p>
						${schedule_html}
					</td>
					<td>
						<p style="font-family:Gotham, 'Helvetica Neue', Helvetica, Arial, sans-serif; padding:0; font-size:14px; line-height:21px; margin:10px 0; text-align:right;">
							$${person.amount}
						</p>
					</td>
				</tr>`;
            });

            let email = `<!doctype html>
							<head>
								<meta charset="UTF-8">
								<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
								<title>Order Confirmation</title>
							</head>
							<body bgcolor="#f1f1f1">
								<table width="600" border="0" align="center" cellpadding="20" cellspacing="0" bgcolor="#ffffff">
									<tbody>
										<tr>
											<td>
												<table width="100%" border="0" align="center" cellpadding="0" cellspacing="0" bgcolor="#ffffff">
													<tbody>
														<tr style="padding:0; margin:0;">
															<td style="padding:0; margin:0;" colspan="2">
																<img src="https://www.ibj.com/ext/resources/images/2015/ibj-logo.png" width="200">
																<hr style="border:none; border-bottom:solid 1px #000000; margin:10px 0; padding:0;" />
															</td>
														</tr>
														<tr style="padding:0; margin:0;">
															<td style="padding:0; margin:0;" colspan="2">
																<p style="font-family:Gotham, 'Helvetica Neue', Helvetica, Arial, sans-serif; padding:0; margin:0 0 20px 0; font-size:14px;">
																	Transaction ID: <strong>${this.completed_order.transaction_id}</strong><br>
																	Date: <strong>${moment().format("MMMM D, YYYY")}</strong>
																</p>
															</td>
														</tr>
														<tr style="padding:0; margin:0;">
															<td style="padding:0; margin:0;" valign="top">
																<p style="font-family:Gotham, 'Helvetica Neue', Helvetica, Arial, sans-serif; padding:0; font-size:14px; margin:0;"><strong>Billing Contact</strong></p>                                  
																<p style="font-family:Gotham, 'Helvetica Neue', Helvetica, Arial, sans-serif; padding:0; font-size:14px; margin:0 0 20px 0;">
																	${this.completed_order.first_name} ${this.completed_order.last_name}<br>
																	${this.completed_order.street_address} ${this.completed_order.suite ?? ""}<br>
																	${this.completed_order.city} ${this.completed_order.state_code}, ${this.completed_order.postal_code}<br>
																	${this.completed_order.email}<br>
																	${this.completed_order.phone ?? ""}
																</p>
															</td>
														</tr>
														<tr style="padding:0; margin:0;">
															<td style="padding:0; margin:0;" colspan="2">
																<p style="font-family:Gotham, 'Helvetica Neue', Helvetica, Arial, sans-serif; padding:0; font-size:14px; margin:0 0 10px 0;"><strong>Order Information:</strong></p>
															</td>
														</tr>
														<tr style="padding:0; margin:0;">
															<td style="padding:0; margin:0;" colspan="2">
																<table width="600" border="0" cellspacing="0" cellpadding="0">
																	<thead>
																		<tr style="padding:0; margin:0;">
																			<th style="font-family:Gotham, 'Helvetica Neue', Helvetica, Arial, sans-serif; padding:0; font-size:14px; margin:0; text-align:left;">Description</th>
																			<th style="font-family:Gotham, 'Helvetica Neue', Helvetica, Arial, sans-serif; padding:0; font-size:14px; margin:0; text-align:right;">Price</th>
																		</tr>
																	</thead>
																	<tbody>
																		${items}
																	</tbody>
																</table>
															</td>
														</tr>
														<tr style="padding:0; margin:0;">
															<td style="padding:0; margin:0;" colspan="2">
																<hr style="border:none; border-bottom:solid 1px #000000; margin:10px 0; padding:0;" />
																<p style="font-family:Gotham, 'Helvetica Neue', Helvetica, Arial, sans-serif; padding:0; font-size:14px; margin:0; text-align:right;">Total: <strong>$${this.completed_order.amount
                }</strong></p>
															</td>
														</tr>
													</tbody>
												</table>
											</td>
										</tr>
									</tbody>
								</table>
							</body>
							</html>`;

            return email;
        },
    },
};
</script>

<style>
.payment h2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.payment .total {
    background-color: #1f9d55;
    padding: 6px;
    color: #ffffff;
    display: inline-block;
}
</style>
